import type { ReactNode } from 'react';
import { memo } from 'react';

import DrawCentre from './DrawCentre';
import { DrawCentreOptionsProvider, DrawCentreProvider } from './store';
import type { DrawCentreOptions } from './store/types';

import { DrawOptionsProvider, DrawProvider } from '@apps/draw/store';
const App = ({ options, placeholder }: { options: DrawCentreOptions; placeholder?: ReactNode }) => {
  return (
    <DrawCentreOptionsProvider options={options}>
      <DrawCentreProvider>
        <DrawOptionsProvider options={options}>
          <DrawProvider>
            <DrawCentre placeholder={placeholder} />
          </DrawProvider>
        </DrawOptionsProvider>
      </DrawCentreProvider>
    </DrawCentreOptionsProvider>
  );
};

export default memo(App);
